import useViewer from '@vangst/services/oogst/viewer/useViewer'
import Routes from '@vangst/services/routes'
import ClickyExplore from '../../components/navigation/ClickyExplore'

function ConnectSearchSidebar() {
  const { viewer, authenticated } = useViewer()
  const iconText = 'heading-sm text-grey flex space-x-4 items-center'

  const ctaJoinOrDashboard =
    viewer != null
      ? { label: 'View Dashboard', url: Routes.DASHBOARD }
      : { label: 'Join The Network', url: Routes.SIGN_UP }
  const initialNetworkText = authenticated
    ? ''
    : 'Membership has its privileges. When you create your Vangst profile, you get direct access to the largest network of cannabis professionals.'
  const initialSearchText = authenticated
    ? ''
    : 'Just getting started? We got you. Crossing over? We got you. Climbing the Cannabis ladder? We got you.'
  return (
    <div className="grid content-start gap-8">
      <div className="flow-y-sm">
        <h2 className={iconText}>
          <span>Connect</span>
        </h2>
        <p>
          {initialNetworkText}Make connections, forge relationships, and chart
          your course in the cannabis industry - it all starts here.
        </p>

        <ClickyExplore
          as="text-icon"
          className="w-72"
          href={ctaJoinOrDashboard.url}
        >
          {ctaJoinOrDashboard.label}
        </ClickyExplore>
      </div>
      <hr className="text-grey-light" />
      <div className="flow-y-sm">
        <h2 className={iconText}>
          <span>Search</span>
        </h2>
        <p className="text-grey">
          {initialSearchText}Search jobs, follow companies, and set alerts for
          new postings so when it comes to landing your dream job, you never
          miss a beat.
        </p>
        <ClickyExplore as="text-icon" className="w-72" href={Routes.JOBS}>
          Search Jobs
        </ClickyExplore>
      </div>
    </div>
  )
}

export default ConnectSearchSidebar
